import styled from 'styled-components';
import { scrollRedStyles } from '../../../../styles/sharedStyles';

export const StyledAcceptCompetitorPopup = styled.div`
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;

    > form,
    > div {
        &:first-child {
            width: 100%;
            overflow-y: scroll;
            max-height: 600px;

            ${scrollRedStyles};
        }
    }
`;

